import React from 'react'
import { useSelector } from 'react-redux'
import Sites from '@sites/index'
import ConsumerSessionCard from '@apps/components/ConsumerSessionCard'
import DealerSessionCard from '@apps/components/DealerSessionCard'

/**
 * Variant picker — `CheckoutLayout` and other callers can drop in `<SessionCard />`
 * without knowing which user type is active. Renders dealer info + (post-login)
 * Logout for dealers; renders the "checking out as <email>" + Logout card for
 * consumers (only after login).
 */
const SessionCard = () => {
  const { userType } = useSelector((state) => state.common)
  if (userType === Sites.dealer) return <DealerSessionCard />
  return <ConsumerSessionCard />
}

export default SessionCard
